import {Component} from 'substance'
import {NotificationComponent} from './NotificationComponent'
import {Event} from '../../../../lib/constants/Event'
import moment from 'moment'

/**
 * @typedef Component.NotificationListComponent.State
 * @property {Component.NotificationListComponent.Notification[]} notifications
 */

/**
 * @typedef Component.NotificationListComponent.Notification
 * @property {bool} display
 * @property {?string} title
 * @property {string} message
 * @property {timestamp} timestamp
 */

/**
 * A Notification list component
 * @memberof Component
 *
 * @property {Component.Notification.State} state
 */
class NotificationListComponent extends Component {

    getInitialState() {
        return {
            notifications: []
        }
    }

    didMount() {
        this.context.api.events.on('__internal', Event.NOTIFICATION_ADD, (event) => {
            let notifications = this.state.notifications
            notifications.push({
                display: true,
                sticky: event.data.sticky || false,
                title: event.data.title || null,
                message: event.data.message,
                timestamp: moment().format('X'),
            })
            this.setState({notifications: notifications})
        })
    }

    dispose() {
        this.context.api.events.off('__internal', Event.NOTIFICATION_ADD)
    }

    removeNotification(notification) {
        notification.display = false
        this.rerender()
    }

    render($$) {
        const el = $$('div')
            .addClass('imc-notifications light')
            .ref('notification-list')

        const activeNotifications = this.state.notifications.map((notification, idx) => {
            return $$(NotificationComponent, {
                sequence: idx,
                notification: notification,
                hideNotification: (notification) => {
                    this.removeNotification(notification)
                }
            }).ref('notification_' + idx)
        })

        el.append(activeNotifications)
        return el
    }
}

export {NotificationListComponent}
